'use client';

/**
 * OrganizationHeader
 *
 * Header component for organization detail page showing:
 * - Back link to organizations list
 * - Organization logo
 * - Organization name and slug
 */

import { Button, Heading, Inline, OrgLogo, Stack, Text } from '@cortex/ui';
import { useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

interface Organization {
  id: string;
  name: string;
  slug: string;
  logo_url: string | null;
}

interface OrganizationHeaderProps {
  organization: Organization;
}

export function OrganizationHeader({ organization }: OrganizationHeaderProps) {
  const navigate = useNavigate();

  return (
    <Stack gap="md">
      {/* Back link */}
      <Button
        variant="ghost"
        size="sm"
        onClick={() => navigate({ to: '/admin/organizations' })}
        className="-ml-2 gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Organizations
      </Button>

      {/* Organization info */}
      <Inline gap="md">
        <OrgLogo
          src={organization.logo_url}
          name={organization.name}
          size="lg"
        />
        <Stack gap="none">
          <Heading level={1} className="text-2xl font-bold">
            {organization.name}
          </Heading>
          <Text color="muted" size="sm">
            {organization.slug}
          </Text>
        </Stack>
      </Inline>
    </Stack>
  );
}
